// * ========================================================================
// * Animated anchor link scrolling
// *
// * Sample usage:
// * <a class="js-anchor-scroll" href="#foo">Click</a>
// * <div id="foo">Scroll to me</div>
// * ========================================================================

'use strict';

import $ from 'jquery'; //npm package

var anchorScroll = (function() {

  function init() {
    //On page load
    if(window.location.hash) {
      window.scrollTo(0, 0);
      const hash = window.location.hash;
      const $target = $(hash);
      animate($target, hash);
    }

    //On click
    $('body').on('click', '.js-anchor-scroll', function(e) {
      const hash = this.hash;
      const href = $(this).attr('href');

      //If link points to a different page, not this one - dont prevent.
      if(hash === href) {
        const $target = $(hash);
        e.preventDefault();
        animate($target, hash);
      }
    });
  }

  function animate(target, hash) {

    if(target.length) {
      let topPosition = target.offset().top - 80;

      $(document.scrollingElement).animate({scrollTop: topPosition}, 300, function() {
        //Update hash to url
        history.replaceState(null, null, hash);
      });
    }
  }

  return {
    init: init
  };

})();

export default anchorScroll;
